import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface MediaAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description?: string;
  media: Parse.File;
  tenant?: OD3_Tenant;
}

export class Media extends Parse.Object<MediaAttributes> {
  static className: string = "OD3_Maintenance_Media";

  constructor(data?: Partial<MediaAttributes>) {
    super("OD3_Maintenance_Media", data as MediaAttributes);
  }

  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }
  get media(): Parse.File {
    return super.get("media");
  }
  set media(value: Parse.File) {
    super.set("media", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Media", Media);
